// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdditionalClausePermissions {
    static _ = 'AdditionalClause';

    static View = class {
        static _ = 'AdditionalClause.View';

        static All = 'AdditionalClause.View.All';
        static Own = 'AdditionalClause.View.Own';
    };

    static Action = class {
        static _ = 'AdditionalClause.Action';

        static Edit = 'AdditionalClause.Action.Edit';
        static Create = 'AdditionalClause.Action.Create';
        static Delete = 'AdditionalClause.Action.Delete';
    };

}

export class AdministrationPermissions {
    static _ = 'Administration';

    static User = class {
        static _ = 'Administration.User';

        static ViewAll = 'Administration.User.ViewAll';
        static ViewOwn = 'Administration.User.ViewOwn';
        static Edit = 'Administration.User.Edit';
        static Create = 'Administration.User.Create';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static ViewAll = 'Administration.Role.ViewAll';
        static ViewOwn = 'Administration.Role.ViewOwn';
        static Edit = 'Administration.Role.Edit';
        static Create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static ViewAll = 'Administration.Organization.ViewAll';
        static ViewOwn = 'Administration.Organization.ViewOwn';
        static Edit = 'Administration.Organization.Edit';
        static Create = 'Administration.Organization.Create';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static View = 'Administration.Settings.View';
        static Edit = 'Administration.Settings.Edit';
    };

}

export class CloseEventPermissions {
    static _ = 'CloseEvent';

    static View = class {
        static _ = 'CloseEvent.View';

        static All = 'CloseEvent.View.All';
    };

    static Action = class {
        static _ = 'CloseEvent.Action';

        static Create = 'CloseEvent.Action.Create';
        static Edit = 'CloseEvent.Action.Edit';
        static Delete = 'CloseEvent.Action.Delete';
    };

}

export class CodeListPermissions {
    static _ = 'CodeList';

    static Action = class {
        static _ = 'CodeList.Action';

        static Create = 'CodeList.Action.Create';
        static Delete = 'CodeList.Action.Delete';
        static Edit = 'CodeList.Action.Edit';
    };

    static View = class {
        static _ = 'CodeList.View';

        static Item = 'CodeList.View.Item';
        static List = 'CodeList.View.List';
    };

}

export class CustomerPermissions {
    static _ = 'Customer';

    static View = class {
        static _ = 'Customer.View';

        static All = 'Customer.View.All';
        static Own = 'Customer.View.Own';
    };

    static Action = class {
        static _ = 'Customer.Action';

        static Cancel = 'Customer.Action.Cancel';
        static Create = 'Customer.Action.Create';
        static Edit = 'Customer.Action.Edit';
        static ConnectCustomer = 'Customer.Action.ConnectCustomer';
        static Delete = 'Customer.Action.Delete';
    };

}

export class EmailNotificationPermissions {
    static _ = 'EmailNotification';

    static View = class {
        static _ = 'EmailNotification.View';

        static All = 'EmailNotification.View.All';
        static Own = 'EmailNotification.View.Own';
    };

    static Action = class {
        static _ = 'EmailNotification.Action';

        static Create = 'EmailNotification.Action.Create';
        static Edit = 'EmailNotification.Action.Edit';
        static Delete = 'EmailNotification.Action.Delete';
        static CreateEmailEvent = 'EmailNotification.Action.CreateEmailEvent';
        static EditEmailEvent = 'EmailNotification.Action.EditEmailEvent';
        static DeleteEmailEvent = 'EmailNotification.Action.DeleteEmailEvent';
    };

}

export class FaqPermissions {
    static _ = 'Faq';

    static Action = class {
        static _ = 'Faq.Action';

        static Save = 'Faq.Action.Save';
        static Delete = 'Faq.Action.Delete';
    };

    static View = class {
        static _ = 'Faq.View';

        static List = 'Faq.View.List';
    };

}

export class InternalPriceListsPermissions {
    static _ = 'InternalPriceLists';

    static Action = class {
        static _ = 'InternalPriceLists.Action';

        static Create = 'InternalPriceLists.Action.Create';
        static Delete = 'InternalPriceLists.Action.Delete';
        static Edit = 'InternalPriceLists.Action.Edit';
    };

    static View = class {
        static _ = 'InternalPriceLists.View';

        static Item = 'InternalPriceLists.View.Item';
        static List = 'InternalPriceLists.View.List';
    };

}

export class ListFilterPermissions {
    static _ = 'ListFilter';

    static View = class {
        static _ = 'ListFilter.View';

        static All = 'ListFilter.View.All';
    };

    static Action = class {
        static _ = 'ListFilter.Action';

        static Create = 'ListFilter.Action.Create';
    };

}

export class NoticeBoardPermissions {
    static _ = 'NoticeBoard';

    static Action = class {
        static _ = 'NoticeBoard.Action';

        static Create = 'NoticeBoard.Action.Create';
        static Edit = 'NoticeBoard.Action.Edit';
    };

    static View = class {
        static _ = 'NoticeBoard.View';

        static Deactivated = 'NoticeBoard.View.Deactivated';
        static List = 'NoticeBoard.View.List';
    };

}

export class OfferPermissions {
    static _ = 'Offer';

    static View = class {
        static _ = 'Offer.View';

        static All = 'Offer.View.All';
        static Own = 'Offer.View.Own';
    };

    static Action = class {
        static _ = 'Offer.Action';

        static Create = 'Offer.Action.Create';
        static CreateVersion = 'Offer.Action.CreateVersion';
        static Edit = 'Offer.Action.Edit';
        static Cancel = 'Offer.Action.Cancel';
        static ToApproval = 'Offer.Action.ToApproval';
        static Approve = 'Offer.Action.Approve';
        static Accept = 'Offer.Action.Accept';
        static Reject = 'Offer.Action.Reject';
        static Clone = 'Offer.Action.Clone';
    };

}

export class ServiceTemplatePermissions {
    static _ = 'ServiceTemplate';

    static View = class {
        static _ = 'ServiceTemplate.View';

        static All = 'ServiceTemplate.View.All';
        static Own = 'ServiceTemplate.View.Own';
        static ViewServiceTemplate = 'ServiceTemplate.View.ViewServiceTemplate';
    };

    static Action = class {
        static _ = 'ServiceTemplate.Action';

        static Edit = 'ServiceTemplate.Action.Edit';
        static Create = 'ServiceTemplate.Action.Create';
        static Delete = 'ServiceTemplate.Action.Delete';
    };

}

export class TariffPriceListPermissions {
    static _ = 'TariffPriceList';

    static View = class {
        static _ = 'TariffPriceList.View';

        static List = 'TariffPriceList.View.List';
        static Item = 'TariffPriceList.View.Item';
    };

    static Action = class {
        static _ = 'TariffPriceList.Action';

        static Create = 'TariffPriceList.Action.Create';
        static Edit = 'TariffPriceList.Action.Edit';
        static Delete = 'TariffPriceList.Action.Delete';
    };

}


